var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schedule-vue-sample",staticStyle:{"height":"100%"}},[_c('ejs-schedule',{attrs:{"selectedDate":_vm.selectedDate,"eventSettings":_vm.eventSettings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }